<template>
  <div class="vue timparty-banners-carousel banners-carousel" v-if="access_token && banners">
    <LoaderOverlay v-if="loading"/>

    <div class="paragraph-carousel-container">
      <div class="paragraph-carousel-controls">
        <div>
          <a href="#" @click.prevent="sliderGoto('prev')"><img :src="themePath('/images/arrow-left.svg')"></a>
          <a href="#" @click.prevent="sliderGoto()"><img :src="themePath('/images/arrow-right.svg')"></a>
        </div>
      </div>

      <div class="banners-carousel paragraph-carousel">
        <div class="paragraph-carousel-slide" v-for="banner in banners" v-bind:key="banner.rewardId">
          <div class="row row-eq-height no-gutters">
            <div class="col-md-6 order-2 order-md-1 d-flex justify-content-end">
              <div class="half-container mx-0 px-3">
                <div class="slide-content d-flex align-items-top">
                  <div>
                    <div v-html="banner.title" class="text-black"></div>

                    <div class="mt-4 text-black" v-if="banner.description" v-html="banner.description.base"></div>

                    <div v-if="banner.notification" class="btn-actions">
                      <a @click="statsClick(banner)" :href="banner.banner.url"
                         :target="banner.banner.target">{{ banner.banner.link_label }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 order-1 order-md-2">
              <div class="slide bg-dark bg-cover  slide-image"
                   :style="'background-image: url(' + banner.banner.image + ')'">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="paragraph-carousel-footer">
        <div class="container">

          <div class="paragraph-carousel-dots"></div>


<!--          <div v-if="typeof banner_message.html !== 'undefined'" v-html="banner_message.html" class="paragraph-carousel-highlight text-center"></div>-->
<!--          <div v-else-if="footermsg !== ''" v-html="formattedFooterMessage" class="paragraph-carousel-highlight text-center"></div>-->
<!--          <div v-else></div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/* eslint-disable */

import {isNull, isUndefined} from "lodash";
import TimPartyMixin         from '../mixins/TimPartyMixin';
import LoaderOverlay from './LoaderOverlay.vue'
import RewardsCard   from './RewardsCard.vue'
import $             from 'jquery';
import 'slick-carousel';

export default {
  name: 'BannersCarousel',
  mixins: [TimPartyMixin],
  components: {LoaderOverlay, RewardsCard},
  props: {
    apiUrl: String,
    catalogUrl: String,
    footermsg: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: function () {
    return {
      banners: [],
      banner_message: []
    };
  },
  mounted: function () {
    this.setApiUrl(this.apiUrl);
    // this.getBannerTime();

    if (this.access_token) {
      this.getBanners();
    }

  },
  methods: {
    // data-slick='{"slidesToShow": 1, "slidesToScroll": 1, "dots": true, "infinite": true, "appendDots": ".paragraph-carousel-dots"}'
    activateSlider: function () {
      this.$nextTick(function () {
        $('.banners-carousel').slick({
          dots: true,
          infinite: true,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          appendDots: '.paragraph-carousel-dots'
          /*
          responsive: [

              {
                  breakpoint: 991,
                  settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1,
                      dots: false,
          //
                  }
              },
              {
                  breakpoint: 520,
                  settings: {
                      slidesToShow: 1.1,
                      slidesToScroll: 1,
                      arrows: false,
                      dots: false,
                  }
              }
          ]
          */
        });
      });
    },

    getBanners: function () {

      var self = this;

      var payload = {
        action: 'getBanners',
        access_token: this.access_token
      };

      self.loading = true;
      this.callApi(payload, function (response) {
        self.loading = false;

        if (response.rewards != undefined) {

          var rewards = response.rewards.map(function (item) {

            if (item.notification != undefined && item.notification.url != undefined) {
              item.banner = {
                link_label: 'SCOPRI SUBITO',
                image: self.getBannerImage(item)
              };
              if (item.template == 'BANNERESTERNO') {
                item.banner.target = '_blank';
                item.banner.url    = item.notification.url + '?token=' + self.access_token;
              }
              else {
                item.banner.target = '_self';
                item.banner.url    = item.notification.url
              }
            }

            return item;

          });

          rewards.sort(function (a, b) {

            var ord_a = parseInt(a.points);
            var ord_b = parseInt(b.points);

            return ord_a - ord_b;

          });

          self.banners = rewards;
          self.activateSlider();
        }

      });

    },

    getBannerTime: function () {
      var self = this;

      var payload = {
        action: 'getBannerTime'
      };

      this.callApi(payload, function (response) {
        self.banner_message = response;
      })
    },

    sliderGoto: function (dir) {

      if (dir == 'prev') {
        $('.banners-carousel').slick('slickPrev');
      }
      else {
        $('.banners-carousel').slick('slickNext');
      }

    },

    getBannerImage: function (banner) {

      let card_image;
      let base_path_images = isUndefined(this.user.base_path_images) || isNull(this.user.base_path_images) ? '' : this.user.base_path_images;
      if (_.has(banner, 'extra.images.slider')) {
        card_image = banner.extra.images.slider[0];
        card_image = !isNull(card_image) ? base_path_images + card_image : null;
      }
      else if (_.has(banner, 'extra.images.featured')) {
        card_image = banner.extra.images.featured[0];
        card_image = !isNull(card_image) ? base_path_images + card_image : null;
      }
      else {
        card_image = null;
      }
      return card_image;

    },

    statsClick: function (banner) {
      this.gtmEvent({
        event: 'bannerClick',
        eventCategory: 'Click',
        eventAction: 'Home Banner',
        eventLabel: this.stripTags(banner.title)
      });


      this.aaEvent('click', {
        form: {
          banner: 'banner slider-' + this.stripTags(banner.title)
        }
      });


    }

  },
  computed: {
    formattedFooterMessage() {
      return '<span>' + this.footermsg + '</span>';
    }
  },
  watch: {
    access_token: function (new_val, old_val) {
      this.getBanners();
    }
  }
}
</script>


